// extracted by mini-css-extract-plugin
module.exports = {"groups":"FAQ_groups__3oFD2","title":"FAQ_title__5fUUb","answerParagraph":"FAQ_answerParagraph__BPazH","link":"FAQ_link__9a6NQ"};